var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-grayBackground w-full"},[_c('div',{staticClass:"px-6 py-12 flex flex-col items-center justify-center lg:px-12 lg:py-[72px] xl:px-16 2xl:px-20 xl:flex-row max-w-7xl mx-auto h-full"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }